import axios from "@axios";

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items;
    },
    getSelectedItems(state) {
      return state.items.map((user) => ({
        value: user.id,
        label: user.name,
      }));
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value;
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const { data } = await axios.get("v1/body-worn/users", { params });

      if (!data.success) {
        return [];
      }

      commit("setData", data.data);
      return data;
    },
  },
};
